import CookieTable from 'js/pages/cookie-table'
import clientLinks from 'js/components/client-links/index.js'
import template from './index.pug'
import menuI from 'js/pages/municipality/index.js'

export default {
  template: template(),
  name: 'CookiesPolicy',
  components: {CookieTable, clientLinks,menuI},
  computed: {
    // Safe access to the current-locale block
    cp() {
      const msg = this.$i18n.getLocaleMessage(this.$i18n.locale) || {}

      return msg.cookiesPolicy || {}
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
